export default {
  setProperty(state, { property, payload }) {
    state[property] = payload;
  },
  setNewOrder(state, { payload }) {
    state.orders = [...state.orders, ...[payload]];
  },
  delProperty(state, { property }) {
    state.orders = state.orders.filter(el => el.id !== property);
  },
};
